import React from 'react';

export const Add = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <path
        fill={props.fill || '#5B2980'}
        d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1C4.134 1 1 4.134 1 8s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm.143 1.905c.276 0 .5.228.5.51V7.43h3.965c.25 0 .459.183.502.412l.008.088c0 .276-.228.5-.51.5H8.642l.001 3.965c0 .25-.183.459-.412.502l-.088.008c-.276 0-.5-.228-.5-.51V8.43H3.627c-.25 0-.459-.183-.502-.412l-.008-.088c0-.276.228-.5.51-.5h4.014l.001-4.015c0-.25.183-.459.412-.502l.088-.008z"
      />
    </g>
  </svg>
);

export const AddCollapseExpand = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="#0A0A0A">
        <g>
          <g>
            <path
              d="M10 2.235c.37 0 .672.284.703.645l.003.061v6.352l6.353.001c.39 0 .706.316.706.706 0 .37-.284.672-.645.703l-.061.003h-6.354v6.353c0 .39-.315.706-.705.706-.37 0-.672-.284-.703-.645l-.003-.061v-6.354H2.94c-.39 0-.706-.315-.706-.705 0-.37.284-.672.645-.703l.061-.003h6.352l.001-6.353c0-.39.316-.706.706-.706z"
              transform="translate(-38 -648) translate(28 638) translate(10 10)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const ActionAdd = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="40" viewBox="0 0 24 40">
    <g fill="none" fillRule="evenodd">
      <g fill="#5B2F91">
        <g>
          <g>
            <path
              d="M12 15.765c.37 0 .672.283.703.645l.003.06v2.824h2.823c.39 0 .706.316.706.706 0 .37-.283.672-.645.703l-.06.003h-2.824v2.823c0 .39-.316.706-.706.706-.37 0-.672-.283-.703-.645l-.003-.06v-2.824H8.47c-.39 0-.706-.316-.706-.706 0-.37.283-.672.645-.703l.06-.003h2.824V16.47c0-.39.316-.706.706-.706z"
              transform="translate(-1156 -194) translate(1156 192) translate(0 2)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
